import addFeaturedCollection from 'src/graphql/mutations/featuredCollections/addFeaturedCollection';
import getAllFeaturedCollections from 'src/graphql/queries/featuredCollections/getAllFeaturedCollections';
import showFeaturedCollection from 'src/graphql/queries/featuredCollections/showFeaturedCollection';

import post from './shared/post';

export default {
  add(values) {
    return post(values, addFeaturedCollection);
  },

  getAll(values) {
    return post(values, getAllFeaturedCollections);
  },

  show(values) {
    return post(values, showFeaturedCollection);
  },
};
